exports = function(val) {
    return val === void 0;
};

module.exports = exports;
